export default __webpack_public_path__ + "static/media/Levitate D4.1 Definition of Quantified Policy Goals.e4d5da0b.pdf";